import { HeartIcon, UtensilsIcon, ClockIcon } from './Icons';

const highlights = [
  {
    icon: HeartIcon,
    title: 'Couples',
    desc: 'Un cadre chaleureux pensé pour partager un moment complice, loin du quotidien.',
  },
  {
    icon: UtensilsIcon,
    title: 'Rendez-vous amoureux',
    desc: 'Menus gourmands, lumière tamisée et service attentionné pour vos soirées à deux.',
  },
  {
    icon: ClockIcon,
    title: 'Moments précieux',
    desc: 'Anniversaires, premières rencontres ou simples retrouvailles — chaque instant compte.',
  },
];

function RomanticVision() {
  return (
    <section className="vision-romance" aria-label="Notre vision pour les couples">
      <div className="vision-romance-inner">
        <header className="vision-romance-header">
          <p className="vision-romance-tag">Notre vision</p>
          <h2 className="vision-romance-title">
            Un restaurant où l&apos;amour a sa place
          </h2>
          <p className="vision-romance-script">Couples &amp; rendez-vous amoureux</p>
          <p className="vision-romance-lead">
            DoWhile Food prépare bien plus qu&apos;une adresse gourmande : nous imaginons
            un lieu accueillant où les couples viennent célébrer leurs histoires, savourer
            un dîner en tête-à-tête et créer des souvenirs autour d&apos;une table.
          </p>
        </header>

        <div className="vision-romance-grid">
          {highlights.map(({ icon: Icon, title, desc }) => (
            <article key={title} className="vision-romance-card">
              <div className="vision-romance-icon">
                <Icon size={22} />
              </div>
              <h3 className="vision-romance-card-title">{title}</h3>
              <p className="vision-romance-card-desc">{desc}</p>
            </article>
          ))}
        </div>

        <p className="vision-romance-footnote">
          Bientôt, venez vivre cette expérience dans notre futur restaurant à Yaoundé.
        </p>
      </div>
    </section>
  );
}

export default RomanticVision;
